/* ==========================================================================
   SERPROMAQ - MOTOR Y MODAL DE COTIZACIONES DINÁMICAS
   ========================================================================== */

const WHATSAPP_PHONE = '573168275829'; // Teléfono comercial oficial SERPROMAQ Colombia

export function initQuoteModal() {
  const modalOverlay = document.getElementById('quoteModal');
  const modalClose = document.getElementById('modalClose');
  const quoteForm = document.getElementById('quoteForm');

  if (!modalOverlay) return;

  // Delegación global en el document: captura cualquier botón o enlace con .btn-trigger-quote, .btn-quote-item, etc.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.btn-trigger-quote, [data-trigger-quote], .btn-quote-item, a[href="#cotizar"], a[href="#quoteModal"]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      const serviceType = trigger.getAttribute('data-service-type') || trigger.getAttribute('data-item-category') || 'venta';
      const itemTitle = trigger.getAttribute('data-item-title') || '';
      openQuoteModal({ category: serviceType, title: itemTitle });
    }
  });

  // Close triggers
  modalClose?.addEventListener('click', (e) => {
    e.preventDefault();
    closeQuoteModal();
  });

  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) {
      e.preventDefault();
      closeQuoteModal();
    }
  });

  // ESC key to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
      closeQuoteModal();
    }
  });

  // Form submission logic -> Formats to WhatsApp
  quoteForm?.addEventListener('submit', (e) => {
    e.preventDefault();

    const service = document.getElementById('modalService')?.value || 'venta';
    const itemPreloaded = document.getElementById('modalItemPreloaded')?.value || '';
    const capacity = document.getElementById('modalCapacity')?.value || '1.5 a 2.5 Toneladas';
    const name = document.getElementById('modalName')?.value.trim() || '';
    const company = document.getElementById('modalCompany')?.value.trim() || '';
    const city = document.getElementById('modalCity')?.value.trim() || '';
    const phone = document.getElementById('modalPhone')?.value.trim() || '';
    const message = document.getElementById('modalNotes')?.value.trim() || '';

    if (!name || !phone) {
      alert('Por favor completa tu nombre y número de teléfono.');
      return;
    }

    // Enviar registro y notificación por correo a postulaciones@serpromaqsas.com
    const formData = new FormData();
    formData.append('type', 'cotizacion');
    formData.append('name', name);
    formData.append('phone', phone);
    formData.append('role', `Cotización: ${service.toUpperCase()}${itemPreloaded ? ' - ' + itemPreloaded : ''}`);
    formData.append('experience', company ? `Empresa: ${company}${city ? ' | Ciudad: ' + city : ''}` : (city ? `Particular | Ciudad: ${city}` : 'Particular'));
    formData.append('brands', `Capacidad: ${capacity} | Item: ${itemPreloaded || 'No especificado'} | Notas: ${message || 'Sin notas adicionales'}`);

    const endpointUrl = window.location.hostname.includes('serpromaqsas.com')
      ? '/send_application.php'
      : 'https://serpromaqsas.com/send_application.php';

    fetch(endpointUrl, {
      method: 'POST',
      body: formData
    }).catch(err => console.warn('Registro de cotización web:', err));

    // Build clear formatted message for WhatsApp
    let whatsappText = `👋 *SOLICITUD DE COTIZACIÓN - SERPROMAQ WEB*\n\n`;
    whatsappText += `📌 *Servicio*: ${service.toUpperCase()}\n`;
    if (itemPreloaded) whatsappText += `🚜 *Equipo/Item*: ${itemPreloaded}\n`;
    whatsappText += `💪 *Capacidad Requerida*: ${capacity}\n`;
    whatsappText += `👤 *Cliente*: ${name}\n`;
    if (company) whatsappText += `🏢 *Empresa*: ${company}\n`;
    if (city) whatsappText += `📍 *Ciudad*: ${city}\n`;
    whatsappText += `📞 *Teléfono*: ${phone}\n`;
    if (message) whatsappText += `📝 *Detalles/Mensaje*: ${message}\n`;

    const encodedText = encodeURIComponent(whatsappText);
    const whatsappUrl = `https://wa.me/${WHATSAPP_PHONE}?text=${encodedText}`;

    // Open WhatsApp in new window
    window.open(whatsappUrl, '_blank');

    closeQuoteModal();
    quoteForm.reset();
  });
}

export function openQuoteModal(context = {}) {
  const modalOverlay = document.getElementById('quoteModal');
  const modalService = document.getElementById('modalService');
  const modalItemPreloaded = document.getElementById('modalItemPreloaded');
  const preloadedWrapper = document.getElementById('preloadedItemWrapper');
  const mobileDrawer = document.getElementById('mobileDrawer');
  const mobileDrawerOverlay = document.getElementById('mobileDrawerOverlay');

  if (!modalOverlay) return;

  // Cerrar menú móvil si estuviera abierto
  if (mobileDrawer) mobileDrawer.classList.remove('open');
  if (mobileDrawerOverlay) mobileDrawerOverlay.classList.remove('open');

  if (context.category && modalService) {
    modalService.value = context.category;
  }

  if (context.title && modalItemPreloaded && preloadedWrapper) {
    modalItemPreloaded.value = context.title;
    preloadedWrapper.style.display = 'block';
  } else if (preloadedWrapper) {
    preloadedWrapper.style.display = 'none';
    if (modalItemPreloaded) modalItemPreloaded.value = '';
  }

  modalOverlay.classList.add('active');
  document.body.style.overflow = 'hidden';
}

export function closeQuoteModal() {
  const modalOverlay = document.getElementById('quoteModal');
  if (modalOverlay) {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
}
